import { useState, useEffect, Dispatch, SetStateAction } from "react";

export const useHighContrast = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [state, setState] = useState(typeof window !== "undefined" && !!window.sessionStorage.getItem('high-contrast-mode'))

  useEffect(() => {
    if (state) {
      sessionStorage.setItem('high-contrast-mode', '1');
    } else {
      sessionStorage.removeItem('high-contrast-mode');
    }
  }, [state]);

  return [state, setState]
}

export default useHighContrast;